module.exports={
  "singleMapImageWithOverlaidTitleScalebarAndLegend": "Single map image with overlaid title, scalebar, and legend.",
  "separateImagesForMapScalebarAndLegend": "Separate images for map, scalebar, and legend.",
  "zipArchive": "ZIP Archive",
  "pngImage": "PNG Image"
}
